import { ChangeDetectionStrategy, Component, inject, type OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import config from '../../../../app.config';

@Component({
  selector: 'bng-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  imports: [RouterLink],
  providers: [CookieService],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoutComponent implements OnInit {
  private _router = inject(Router);
  private _cookieService = inject(CookieService);

  async ngOnInit() {
    // TODO: remove this when we old boss is deprecated
    this._cookieService.delete(config.authCookieName, '/', '.beckshybrids.com');

    // this is temporary until the internal org is migrated to Okta Identity Engine
    await this.terminateInternalOktaSession();
    void this._router.navigate(['/']);
  }

  async terminateInternalOktaSession() {
    const baseUrl = 'https://login.beckshybrids.com/api/v1';
    try {
      await fetch(`${baseUrl}/sessions/me`, {
        method: 'DELETE',
        credentials: 'include',
      });
    } catch {
      // intentionally ignore errors
    }
  }
}
